import styled from 'styled-components'

const Wrapper = styled.section`
border: 1px solid #ccc;
background: white;
margin: 0px;
padding: 10px;

  .label{
    margin: 0px;
    padding: 0px;
  }

  .intro{
    margin: 0px;
    padding: 0px;
  }

  .desc{
    margin: 0px;
    padding: 0px;
    overflow-wrap: break-word;
    max-width: 300px;
  }
`
export default Wrapper
